<template>
  <div>
    <b-modal v-model="confirmDelete" size="sm" hide-header hide-footer centered>
      <div class="d-block text-center p-3">
        Scheduling information will be deleted. Are you sure you want to
        continue?
        <b-row class="mt-4">
          <b-col class="text-center">
            <div
              class="c-pointer"
              @click="
                $router.push({
                  name: 'board.board-layout-page',
                  params: {
                    id: board.board_id,
                    name: board.board_name,
                    site_name: $route.params.name
                  }
                })
              "
            >
              Yes
            </div>
          </b-col>
          <b-col class="text-center">
            <div
              class="font-weight-bold c-pointer"
              @click="confirmDelete = false"
            >
              No
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal
      v-model="confirmArchive"
      size="md"
      hide-header
      hide-footer
      centered
    >
      <div class="d-block text-center p-3 py-4">
        This board, including its children boards, will be archived. Are you
        sure you want to continue?
        <b-row class="mt-5">
          <b-col class="text-center">
            <div class="c-pointer" @click="proceedArchive">
              Yes
            </div>
          </b-col>
          <b-col class="text-center">
            <div
              class="font-weight-bold c-pointer"
              @click="confirmArchive = false"
            >
              No
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-container class="p-relative gen-form-container">
      <div class="header-text-container" :class="isMobile ? 'pr-3' : 'w-100 '">
        <b-breadcrumb :items="items" class="pl-0 bg-transparent"></b-breadcrumb>
        <div
          class="d-flex justify-content-between"
          :class="isMobile ? '' : 'form-container'"
        >
          <div class="w-100">
            <general-information class="mt-3" :can-update="canUpdateDetails" />
            <!-- <testing-information class="mt-3" v-show="showMore" /> -->
            <metering-information
              class="mt-3"
              v-show="showMore"
              :can-update="canUpdateDetails"
            />

            <div class="mt-3">
              <b-link @click="showMore = !showMore">
                <b>
                  {{ showMore ? 'Show less' : 'Show more' }}
                  <b-icon
                    class="ml-2"
                    :icon="showMore ? 'chevron-up' : 'chevron-down'"
                  ></b-icon>
                </b>
              </b-link>
            </div>
          </div>
        </div>
      </div>
    </b-container>

    <div class="board-info" :style="`height: ${height}px`">
      <div class="cover-overlay"></div>
    </div>

    <b-container class="overflow-auto py-0 my-5">
      <div :class="isMobile ? '' : 'd-flex justify-content-between'">
        <div class="flex-shrink-0">
          <h2 class="mb-3">
            <b>Board Schedule</b>
          </h2>
          <b-link>
            <b>Need help?</b>
          </b-link>
        </div>
        <div v-if="board" class="d-flex flex-column flex-shrink-0">
          <div class="update d-flex flex-column justify-content-end w-100">
            <div class="text-right">Latest update:</div>
            <div class="text-right">
              {{ `${board.installed_by}, ${board.dateUpdated}` }}
            </div>
          </div>
          <div class="d-flex mt-3 flex-column board__actions">
            <div :class="isMobile ? 'text-center' : 'text-right'">
              <div class="d-flex">
                <b-link
                  class="mr-4"
                  @click="confirmDelete = true"
                  v-if="!showAlert && canUpdateDetails"
                >
                  <b-img
                    width="16"
                    class="rounded-0 mr-2 mb-1"
                    :src="require('@/assets/icons/edit.svg')"
                  ></b-img>
                  <span class="buttontext">Update Layout</span>
                </b-link>
                <b-link
                  class="mr-4"
                  @click="
                    $router.push({
                      name: 'board.view-change-log',
                      params: { name: $route.params.name, id: $route.params.id }
                    })
                  "
                  v-if="!showAlert && canUpdateDetails"
                >
                  <b-icon icon="files" class="mr-2"></b-icon>
                  <span class="buttontext">View Changelog</span>
                </b-link>
                <b-link v-if="canDeleteSchedule" @click="confirmArchive = true">
                  <b-icon icon="trash" class="mr-2"></b-icon>
                  <span class="buttontext">Archive</span>
                </b-link>
              </div>
              <div
                class="d-flex mt-2"
                :class="
                  isMobile ? 'justify-content-start' : 'justify-content-end'
                "
              >
                <b-link
                  v-if="!showAlert && canUpdateDetails"
                  @click="handleDownload"
                  class="mr-4"
                >
                  <b-icon icon="download" class="mr-2"></b-icon>
                  <span class="buttontext">Download</span>
                </b-link>
                <b-link @click="updateAssetModal = true">
                  <b-icon icon="upload" class="mr-2"></b-icon>
                  <span class="buttontext">Asset Photo</span>
                </b-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <board-schedule :can-update="canUpdateSchedule" />
    </b-container>

    <b-alert class="custom-alert" variant="primary" fade :show="showAlert">
      <b-container class="mt-3">
        <div class="d-flex justify-content-between">
          <div>Board layout has been updated.</div>
          <div>
            <div class="c-pointer" @click.prevent="showAlert = false">
              <u>Close</u>
            </div>
          </div>
        </div>
      </b-container>
    </b-alert>
    <b-alert class="custom-alert" variant="primary" fade :show="showAssetAlert">
      <b-container class="mt-3">
        <div class="d-flex justify-content-between">
          <div>Board Asset has been uploaded.</div>
          <div>
            <div class="c-pointer" @click.prevent="showAssetAlert = false">
              <u>Close</u>
            </div>
          </div>
        </div>
      </b-container>
    </b-alert>

    <b-modal
      v-model="updateAssetModal"
      title="Update Asset"
      centered
      class="p-3"
      modal-class="asset-modal"
    >
      <label
        class="asset__uploader"
        :class="{ preview: hasAsset }"
        :style="
          hasAsset
            ? `background-image: url(${asset.base64 || board.assets[0].url});`
            : ''
        "
      >
        <b-icon v-show="!hasAsset" class="h1" icon="camera" size></b-icon>
        <span v-show="!hasAsset">Upload Image</span>
        <input type="file" ref="assetPhoto" @change="setAsset" hidden />
      </label>

      <template v-slot:modal-footer class="asset-footer">
        <b-button
          variant="primary"
          :disabled="uploadAssetLoading || !asset.base64"
          @click="handleUploadAsset"
        >
          <b-spinner small v-if="uploadAssetLoading"></b-spinner>&nbsp;
          {{ hasUploadedAsset ? 'Update' : 'Upload' }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="loading"
          @click="confirmDeleteAsset = true"
          v-if="board.assets && board.assets.length && board.assets[0].url"
        >
          Delete
        </b-button>
      </template>
    </b-modal>
    <b-modal
      v-model="confirmDeleteAsset"
      title="Remove Asset?"
      centered
      class="p-3"
    >
      <p>
        Are you sure you want to remove this asset?
        <br />The asset will be deleted.
      </p>
      <hr class="modal-divider" />
      <template v-slot:modal-footer>
        <b-button class="btn btn-secondary" @click="confirmDeleteAsset = false"
          >Cancel</b-button
        >
        <b-button
          variant="danger"
          :disabled="loading"
          @click="handleRemoveAsset"
        >
          <b-spinner small v-if="loading"></b-spinner>&nbsp;Remove
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import GeneralInformation from '@/components/forms/board/GeneralInformation'
// import TestingInformation from '@/components/forms/board/TestingInformation'
import MeteringInformation from '@/components/forms/board/MeteringInformation'
import BoardSchedule from '@/components/tables/BoardSchedule'

const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

export default {
  components: {
    GeneralInformation,
    // TestingInformation,
    MeteringInformation,
    BoardSchedule
  },

  data() {
    return {
      loading: false,
      uploadAssetLoading: false,
      showMore: false,
      showAlert: false,
      showAssetAlert: false,
      confirmDelete: false,
      confirmArchive: false,
      updateAssetModal: false,
      confirmDeleteAsset: false,
      asset: {
        base64: null,
        file: null
      }
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      board: state => state.board.boardDetails
    }),
    hasAsset() {
      if ((this.board && this.board.assets) || this.asset.base64) {
        return !!this.board.assets.length || this.asset.base64
      }
      return false
    },
    hasUploadedAsset() {
      if (this.board && this.board.assets) {
        return !!this.board.assets.length
      }
      return false
    },
    height() {
      if (!this.isMobile) {
        return this.showMore ? '635' : '425'
      } else {
        return this.showMore ? '1025' : '700'
      }
    },

    items() {
      return [
        { text: 'Home', href: '/dashboard' },
        {
          text: this.$route.params.name,
          href: this.board
            ? `/sites/${this.$route.params.name}/${this.board.site_id}`
            : ''
        },
        {
          text: this.board
            ? `${this.board.board_name}, ${this.board.location}`
            : '',
          href: '#'
        }
      ]
    },

    canUpdateDetails() {
      return this.board && this.user
        ? this.user.is_admin ||
            this.board.permissions.includes('UPDATE_BOARD_DETAILS')
        : false
    },

    canUpdateSchedule() {
      return this.board && this.user
        ? this.user.is_admin ||
            this.board.permissions.includes('UPDATE_BOARD_SCHEDULE')
        : false
    },

    canDeleteSchedule() {
      return this.board && this.user
        ? this.user.is_admin || this.board.permissions.includes('DELETE_BOARD')
        : false
    }
  },

  methods: {
    ...mapActions({
      getBoardDetails: 'board/getBoardDetails',
      archiveBoard: 'board/archiveBoard',
      uploadAsset: 'board/uploadAsset',
      removeAsset: 'board/removeAsset'
    }),

    async setAsset(e) {
      const [file] = e.target.files

      if (file) {
        this.asset = { base64: await toBase64(file), file }
      }
    },
    async handleUploadAsset() {
      if (this.asset.base64) {
        this.uploadAssetLoading = true
        const form = new FormData()
        form.set('assets[]', this.asset.file)
        try {
          await this.uploadAsset({ form, boardId: this.$route.params.id })
          this.showAssetAlert = true
          this.updateAssetModal = false
          this.asset = { base64: null, file: null }
        } catch (error) {
          this.$bvToast.toast('Asset must be 5MB or below.', {
            title: 'Failed to upload asset',
            variant: 'danger',
            solid: true
          })
          this.$refs.assetPhoto.value = ''
        }
        this.uploadAssetLoading = false
      }
    },
    async handleRemoveAsset() {
      this.loading = true
      try {
        await this.removeAsset({
          assetId: this.board.assets[0].id,
          boardId: this.$route.params.id
        })
        this.$bvToast.toast('Asset has been removed.', {
          title: 'Remove Asset',
          variant: 'success',
          solid: true
        })
        this.confirmDeleteAsset = false
        this.updateAssetModal = false
        this.asset = { base64: null, file: null }
      } catch (error) {
        this.$bvToast.toast(
          'Something went wrong. Please try refreshing the page and try again.',
          {
            title: 'Remove Asset',
            variant: 'danger',
            solid: true
          }
        )
      }

      this.loading = false
    },

    handleDownload() {
      const a = document.createElement('a')
      a.href = `${process.env.VUE_APP_API_URL}/boards/${
        this.$route.params.id
      }/schedules/download`
      a.download = true
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },

    async proceedArchive() {
      await this.archiveBoard(this.board.board_id)
      this.confirmArchive = false
      this.$router.push({
        name: 'site.view-site-page',
        params: {
          id: this.board.site_id,
          name: this.$route.params.name,
          activeBoard: this.board.topmost_parent_id || null
        }
      })
    }
  },

  async created() {
    if (this.$route.params.is_updated) {
      this.showAlert = true
    }
    await this.getBoardDetails(this.$route.params.id)
    this.$root.$emit('boardLoaded')
  }
}
</script>

<style lang="scss" scoped>
.form-control:disabled,
.form-control[readonly] {
  background-color: #f8f9fa;
}
.gen-form-container {
  padding-bottom: 72px;
}
.header-text-container {
  position: absolute;
  top: 95px;
  z-index: 2;
}
.header-text {
  font-size: 24px;
  font-weight: bold;
}
.board-info {
  background-color: #f5f5f5;
}
.form-container {
  padding-right: 30px;
}
.mt-56 {
  margin-top: 56px;
}
.breadcrumb {
  display: -webkit-box;
  flex-wrap: unset;
  overflow: hidden;
}
.breadcrumb-item {
  font-weight: bold;
}
.breadcrumb-item + .breadcrumb-item.active {
  font-weight: normal;
}
.breadcrumb-item + .breadcrumb-item::before {
  content: '\203A';
}
.custom-alert {
  height: 80px;
  align: center;
  text-align: left;
}
.buttontext {
  font-size: 14px;
  font-weight: bold;
}

.board__actions {
  @media (max-width: 576px) {
    .mr-4 {
      margin-right: 0.8rem !important;
    }
  }
}
.asset-container {
  position: relative;
  display: block;
}
.remove-asset {
  position: absolute;
  right: -15px;
  bottom: -5px;
  background: #ffffff;
  border-radius: 25px;
  display: block;
}
.remove-icon {
  box-sizing: border-box;
  position: relative;
  display: block;
  transform: scale(1);
  width: 16px;
  height: 15px;
  border: 2px solid;
  border-radius: 22px;
  &:hover {
    box-shadow: 0px 0px 5px #0000004d;
  }
  &::before {
    content: '';
    display: block;
    box-sizing: border-box;
    position: absolute;
    width: 7px;
    height: 2px;
    background: currentColor;
    border-radius: 5px;
    top: 5px;
    left: 3px;
  }
}
.asset__uploader {
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f3f4;
  border-radius: 10px;
  cursor: pointer;

  &.preview {
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
}

::v-deep .asset-modal .modal-footer {
  justify-content: space-between !important;
}
</style>
